const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/prog/admin',
      name: 'prog_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/prog/appl',
      name: 'prog_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/prog/router.js